import { type ReactNode } from "react";

interface CardProps {
  children: ReactNode;
  className?: string;
  padding?: string;
}

export function Card({ children, className = "", padding = "p-3" }: CardProps) {
  return (
    <div
      className={`${padding} w-full bg-white/95 dark:bg-gray-800/90 backdrop-blur-xl rounded-2xl border border-gray-200/50 dark:border-white/[0.08] shadow-sm ${className}`}
    >
      {children}
    </div>
  );
}
